const MAX_REDIRECTS = 2;
const WINDOW_MS = 30_000;
const COUNT_KEY = "auth_redirect_count";
const TS_KEY = "auth_redirect_ts";

/**
 * Redirects to the app root (which renders the sign-in page), tracking how
 * many times this has happened within a 30-second window. Returns false (and
 * does NOT redirect) when the cap is exceeded — callers should render a
 * terminal error state instead.
 *
 * Call clearRedirectCounter() when auth succeeds so a one-off blip doesn't
 * permanently disable automatic redirects.
 */
export function redirectToSignIn(): boolean {
  const now = Date.now();
  const windowStart = parseInt(sessionStorage.getItem(TS_KEY) ?? "0", 10);
  const storedCount = parseInt(sessionStorage.getItem(COUNT_KEY) ?? "0", 10);

  const withinWindow = now - windowStart <= WINDOW_MS;
  const count = withinWindow ? storedCount : 0;

  if (count >= MAX_REDIRECTS) return false;

  if (!withinWindow) sessionStorage.setItem(TS_KEY, String(now));
  sessionStorage.setItem(COUNT_KEY, String(count + 1));
  window.location.href = window.location.origin;
  return true;
}

export function clearRedirectCounter(): void {
  sessionStorage.removeItem(COUNT_KEY);
  sessionStorage.removeItem(TS_KEY);
}

export function isRedirectCapped(): boolean {
  const windowStart = parseInt(sessionStorage.getItem(TS_KEY) ?? "0", 10);
  const count = parseInt(sessionStorage.getItem(COUNT_KEY) ?? "0", 10);
  return Date.now() - windowStart <= WINDOW_MS && count >= MAX_REDIRECTS;
}
